import { TypedMatNode } from "../_Base";
import { BaseController } from "./_BaseController";
import { NodeParamsConfig, ParamConfig } from "../../utils/params/ParamsConfig";
import { isBooleanTrue } from "../../../../core/BooleanValue";
import PCSS from "./shadows/pcss/glsl/PCSS.glsl";
import PCSSGetShadow from "./shadows/pcss/glsl/PCSSGetShadow.glsl";
import SHADOW_MAP_PARS_FRAGMENT from "three/src/renderers/shaders/ShaderChunk/shadowmap_pars_fragment.glsl";
import { ThreeToGl } from "../../../../core/ThreeToGl";
export function PCSSParamConfig(Base) {
  return class Mixin extends Base {
    constructor() {
      super(...arguments);
      this.shadowPCSS = ParamConfig.BOOLEAN(0, {
        callback: (node) => {
          PCSSController.PARAM_CALLBACK_setRecompileRequired(node);
        },
        separatorBefore: true
      });
      this.shadowPCSSFilterSize = ParamConfig.FLOAT(1, {
        visibleIf: { shadowPCSS: 1 },
        range: [0, 10],
        rangeLocked: [true, false]
      });
    }
  };
}
class PCSSParamsConfig extends PCSSParamConfig(NodeParamsConfig) {
}
class PCSSMapMatNode extends TypedMatNode {
}
export class PCSSController extends BaseController {
  constructor(node) {
    super(node);
    this.node = node;
  }
  initializeNode() {
  }
  static filterFragmentShader(node, fragmentShader) {
    const PCSSWithDefines = `
#define PCSS_FILTER_SIZE ${ThreeToGl.float(node.pv.shadowPCSSFilterSize)}
${PCSS}
`;
    let shadowParsFragmentModified = SHADOW_MAP_PARS_FRAGMENT;
    shadowParsFragmentModified = shadowParsFragmentModified.replace("#ifdef USE_SHADOWMAP", `#ifdef USE_SHADOWMAP
${PCSSWithDefines}
				`);
    shadowParsFragmentModified = shadowParsFragmentModified.replace("#if defined( SHADOWMAP_TYPE_PCF )", `
				${PCSSGetShadow}
				#if defined( SHADOWMAP_TYPE_PCF )`);
    fragmentShader = fragmentShader.replace("#include <shadowmap_pars_fragment>", shadowParsFragmentModified);
    return fragmentShader;
  }
  async update() {
    var _a, _b;
    const matNode = this.node;
    if (!matNode.assemblerController) {
      return;
    }
    const callbackName = "PCSS";
    if (isBooleanTrue(this.node.pv.shadowPCSS)) {
      (_a = matNode.assemblerController()) == null ? void 0 : _a.addFilterFragmentShaderCallback(callbackName, (fragmentShader) => PCSSController.filterFragmentShader(this.node, fragmentShader));
    } else {
      (_b = matNode.assemblerController()) == null ? void 0 : _b.removeFilterFragmentShaderCallback(callbackName);
    }
  }
  static async update(node) {
    node.controllers.PCSS.update();
  }
  static PARAM_CALLBACK_setRecompileRequired(node) {
    node.controllers.PCSS.update();
  }
}
